import React, { useState, useEffect } from "react";
import { PRODUCT_CATEGORY_DETAILS_LISTING_COLUMNS } from "../../../utils/constant";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  TableSortLabel,
  Box,
  IconButton,
} from "@mui/material";
import RecordNotFound from "../../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_CATEGORY_VALIDATIONS } from "../../../utils/Validation";
import AddProductCategory from "./AddCategory";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import ClearIcon from "@mui/icons-material/Clear";
import {
  onUpdateProductCategoryService,
  CategoryChangeStatusService,
  onAddProductCategoryService,
} from "../../../services/MasterDataManagementService";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";

const CategoryList = ({
  totalElements,
  categoryList,
  onSearch,
  fetchCategoryList,
  handleTableChanges,
  setLoading,
  showNotification,
  setCategoryList,
  noRecord,
}) => {
  const [searchedRows, setSearchedRows] = useState(categoryList);
  const [categoryNameSearch, setcategoryNameSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddCategoryDialog, setOpenAddCategoryDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [categoryId, setCategoryId] = useState("");
  const [selected, setSelected] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("categoryName");
  const [sortValue, setSortValue] = useState("ASC");
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserInfo = auth.ldapParam;
  const [searchValue_, setsearchValue_] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserInfo.userId,
    active: 1,
    modifiedBy: loginUserInfo.userId,
  });
  const formOption = {
    resolver: yupResolver(ADD_CATEGORY_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue
  } = useForm(formOption);

  useEffect(() => {
    reset(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddCategoryDialog]);

  useEffect(() => {
    setSearchedRows(categoryList);
  }, [categoryNameSearch, categoryList]);

  const searchText = async (e) => {
    setSearchValue(e.target.value);
    setcategoryNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      onclickClear();
    }
  };

  const handleClickOpenCategoryDialog = () => {
    setOpenAddCategoryDialog(true);
  };

  const handleCloseCategoryDialog = () => {
    setOpenAddCategoryDialog(false);
    setIsEditMode(false);
    setIsUpdateButton(true);
    setFormData({});
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
      const requestBody = {
        status: true,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,

        search: searchValue && searchValue.trim(),
      };
      setsearchValue_(searchValue)
      setIsSearchBtnClick(true);
      setSelected([]);
      setDisbaleUpdateButton(true)
      await onSearch(requestBody, searchValue && searchValue.trim());
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    setcategoryNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
    const paginationObject = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,
    };
    setsearchValue_(null)
    setSelected([]);
    setDisbaleUpdateButton(true)
    await fetchCategoryList("categoryName", false, null, paginationObject);

    setSearchValue("");
    setPage(0);
    setMaxPage(0);
    setClearSearch(false);
    setcategoryNameSearch("");
    setIsSearchBtnClick(false);
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(
      paginationValues,
      false,
      sortValue,
      orderBy,
      searchValue_
    );
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(
        paginationValues,
        true,
        sortValue,
        orderBy,
        searchValue_
      );
    }
    setPage(newPage);
  };

  const onAddCategorySubmit = async (data) => {
    try {
      let obj = {
        categoryCode: data.categoryCode.trim(),
        categoryName: data.categoryName.trim(),
        categoryId: categoryId ? categoryId : null,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.modifiedBy,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        active: formValues.active ? true : false,
      };

      const res = !isEditMode
        ? await onAddProductCategoryService(obj)
        : await onUpdateProductCategoryService(obj);
      if (res.statusCode === 6) {
        const newCategoryList = [...categoryList];
        const index = newCategoryList.findIndex(
          (x) => x.categoryId === categoryId
        );
        newCategoryList[index] = { ...categoryList[index], ...obj };
        setCategoryList(newCategoryList);
        handleCloseCategoryDialog(false);
        setIsUpdateButton(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()
        // if (!isEditMode) {
        //   setPage(0);
        //   setMaxPage(0);

        //   const timer = setTimeout(async () => {
        //     await fetchCategoryList("categoryName", true);
        //   }, 1000);
        //   return () => clearTimeout(timer);
        // }
      } else {
        showNotification("Error", res.message, "error");
        handleCloseCategoryDialog(false);
      }
    } catch (err) {
      console.log("err catch", err);
      throw err;
    }
  };

  const handleClickEditCategory = (item) => {
    if (item) {
      reset(item);
    }
    setOpenAddCategoryDialog(true);
    setIsEditMode(true);
    setCategoryId(item?.categoryId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item.createdBy ? item.createdBy : 1,
      active: item?.active ? item.active : 0,
    });
    setFormData({ ...item });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - categoryList.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = categoryList.map((currentRow) => {
      if (currentRow.categoryId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setCategoryList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = categoryList.find(
        (record) => record.categoryId === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          categoryId: tempItem.categoryId,
        });
      }
    });
    try {
      const res = await CategoryChangeStatusService(resultRecords);
      if (res.statusCode === 6) {
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationObject = {
      pageNumber: 0,
      pageSize: rowsPerPage ? rowsPerPage : 10,
    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchCategoryList(property, isAsc,searchValue_&& searchValue_.trim(), paginationObject);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    //setSearchValue("");
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6">
              Category Listing ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
                {/* <SearchIcon
                  className="searchIcon"
                  onClick={() => searchOnClick("categoryName")}
                /> */}
                <input
                  type="text"
                  placeholder="By Name"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                  <SearchIcon
                    //className="searchIcon"
                    //className={searchValue === '' ? 'searchIcon emptySearchVal':'searchIcon'}
                    onClick={() => searchOnClick("firstName")}
                  />
                </IconButton>

                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="searchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add Category">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenCategoryDialog();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}>
                  Add Category
                </Button>
              </Tooltip>
              <Tooltip title="Update Category Status" >
               <span> <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}>
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button></span>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 1 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    // onSelectAllClick={handleSelectAllClick}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.categoryId);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={index}>
                              <TableCell size="small" key={"categoryCode"}>
                                {row["categoryCode"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                key={"categoryName"}
                                title={
                                  row?.categoryName ? row.categoryName : ""
                                }>
                                {(row.categoryName &&
                                  row.categoryName?.slice(0, 20)) ||
                                  "-"}
                                {row.categoryName &&
                                row.categoryName.length > 20
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  // checked={row.active}
                                  checked={(isItemSelected, row.active)}
                                  classes={{ root: "custom-checkbox-root" }}
                                  onClick={(event) =>
                                    handleActiveChange(event, row.categoryId)
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <EditIcon
                                  sx={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "#567aac",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                  // className="brandSearchClear"
                                  onClick={() => handleClickEditCategory(row)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}>
                          <TableCell colSpan={4} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={4}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={4} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddProductCategory
              openDialog={openAddCategoryDialog}
              handleClose={handleCloseCategoryDialog}
              register={register}
              setError={setError}
              handleSubmit={handleSubmit}
              errors={errors}
              onAddCategorySubmit={onAddCategorySubmit}
              isEditMode={isEditMode}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CategoryList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {PRODUCT_CATEGORY_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.categoryId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" || headCell.id === "active") && true
              }>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
